import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


// import {
// 	statisticsAction,
// 	statisticsCloseAction
// } from '../../../actions/settingsAction.js';


import {
	statisticsAction,
	statisticsCloseAction
} from '../../../actions/settingsAction.js';

import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom.min.js';
import { useParams } from "react-router-dom";
const RoleAccessControl = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const defaultChecked = false;

	const [selectedItems, setSelectedItems] = useState([]);
	const [isChecked, setIsChecked] = useState({ defaultChecked });


	const [checkbox, setCheckbox] = useState([]);

	const history = useHistory();
	// const [data, setData] = useState([]);
	// const [leavedetaildata, setLeaveDetailData] = useState([]);
	


	const { search } = useLocation();
	const searchparams = new URLSearchParams(search);
	const param = searchparams.get("id");
	//const handleChange = (e) => setCheckbox(e.target.checked);










  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/payslipdisplay/${param}`)
    //   .then(res => console.log(res.data))
      .then(res => setData(res.data))
      .catch(err => console.log(err));
  }, [param]);

  if (!data) return <h3>Loading...</h3>;


	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />


						</div>
					</div>

          <div className="container-fluid">
          <div className="row">

           {data?.salary?.sl_leaves > 0 && (          
          <div className="col-lg-3 col-md-2">
          <div className="card">
          <div className="card-body w_sparkline">
          <div className="details">
          <span>SL</span>
          <h3 className="mb-0">
          
          <span className="counter">	<CountUp  /> {data.salary.sl_leaves}</span>
          </h3>
          </div>
          <div className="w_chart">
          <div id="mini-bar-chart1" className="mini-bar-chart" />
          </div>
          </div>
          </div>
          </div>

            )}

           {data?.salary?.cl_leaves > 0 && (
          <div className="col-lg-3 col-md-2">
          <div className="card">
          <div className="card-body w_sparkline">
          <div className="details">
          <span>CL</span>
          <h3 className="mb-0">
          {/* /<CountUp end={user_info.leave_available} /> */}
          <span >{data.salary.cl_leaves}</span>
          </h3>
          </div>
          <div className="w_chart">
          <span
          ref={sparkline2}
          id="mini-bar-chart2"
          className="mini-bar-chart"
          />
          </div>
          </div>
          </div>
          </div>

            )}


            {data?.salary?.mat_leaves > 0 && (
          <div className="col-lg-3 col-md-2">
          <div className="card">
          <div className="card-body w_sparkline">
          <div className="details">
          <span>ML</span>
          <h3 className="mb-0">
          {/* /<CountUp end={user_info.leave_available} /> */}
          <span >{data.salary.mat_leaves}</span>
          </h3>
          </div>
          <div className="w_chart">
          <span
          ref={sparkline2}
          id="mini-bar-chart2"
          className="mini-bar-chart"
          />
          </div>
          </div>
          </div>
          </div>

            )}


             {data?.salary?.pl_leaves > 0 && (
          <div className="col-lg-3 col-md-2">
          <div className="card">
          <div className="card-body w_sparkline">
          <div className="details">
          <span>PL</span>
          <h3 className="mb-0">
          {/* /<CountUp end={user_info.leave_available} /> */}
          <span >{data.salary.pl_leaves}</span>
          </h3>
          </div>
          <div className="w_chart">
          <span
          ref={sparkline2}
          id="mini-bar-chart2"
          className="mini-bar-chart"
          />
          </div>
          </div>
          </div>
          </div>

            )}


             {data?.salary?.co_leaves > 0 && (
          <div className="col-lg-3 col-md-2">
          <div className="card">
          <div className="card-body w_sparkline">
          <div className="details">
          <span>CO</span>
          <h3 className="mb-0">
          {/* /<CountUp end={user_info.leave_available} /> */}
          <span >{data.salary.co_leaves}</span>
          </h3>
          </div>
          <div className="w_chart">
          <span
          ref={sparkline2}
          id="mini-bar-chart2"
          className="mini-bar-chart"
          />
          </div>
          </div>
          </div>
          </div>

            )}


             {data?.salary?.wo_leaves > 0 && (
          <div className="col-lg-3 col-md-2">
          <div className="card">
          <div className="card-body w_sparkline">
          <div className="details">
          <span>Weekoff</span>
          <h3 className="mb-0">
          {/* /<CountUp end={user_info.leave_available} /> */}
          <span >{data.salary.wo_leaves}</span>
          </h3>
          </div>
          <div className="w_chart">
          <span
          ref={sparkline2}
          id="mini-bar-chart2"
          className="mini-bar-chart"
          />
          </div>
          </div>
          </div>
          </div>

            )}


          </div>
          </div>


					<div className="section-body mt-3">
                    <div className="container-fluid">
                        <div className="row">
                            
                        <div style={{ width: "900px", margin: "20px auto", fontFamily: "Arial" }}>

      {/* Header */}
      <h2 style={{ textAlign: "center" }}>
        Payslip for the month of {data.salary.payment_month}
      </h2>

      {/* Employee Details Table */}
      <table border="1" width="100%" cellPadding="5" style={{ marginBottom: "20px" }}>
        <tbody>
          <tr>
            <td>Name</td><td>{data.employee.name}</td>
            <td>Employee Id</td><td>{data.employee.employee_id}</td>
          </tr>
          <tr>
            <td>Department</td><td>{data.employee.department}</td>
            <td>Designation</td><td>{data.employee.designation}</td>
          </tr>
          <tr>
            <td>Date Of Joining</td><td>{data.employee.date_of_joining}</td>
            <td>PF UAN</td><td>{data.salary.uan_no}</td>
          </tr>
          <tr>
            <td>Total Days</td><td>{data.salary.total_days}</td>
            <td>Days Worked</td><td>{data.salary.days_worked}</td>
          </tr>
          <tr>
            <td>ESIC No</td><td>{data.salary.esi_no}</td>
            <td>Account No</td><td>{data.salary.account_no}</td>
          </tr>

          <tr>
           
            <td>LOP Days</td><td>{data.salary.lop_days}</td>
             <td></td><td></td>
          </tr>
        </tbody>
      </table>

      {/* Earnings & Deductions */}
      <table border="1" width="100%" cellPadding="5">
        <thead style={{ backgroundColor: "#c4e5fd" }}>
          <tr>
            <th>Earnings</th>
            <th>Amount</th>
            <th>Deductions</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {data.earnings.map((row, i) => ( 
            <tr key={i}>
              <td>{row.label}</td>
              <td>{row.amount}</td>
              <td>{data.deductions[i]?.label || 0}</td>
              <td>{data.deductions[i]?.amount || 0}</td>
            </tr>
          ))}

          <tr>
            <td style={{ borderRight: 'hidden' }}><strong>Net Take Home</strong></td>
            <td colSpan="4" >{data.salary.net_take_home}</td>
          </tr>

          <tr>
            <td colSpan="4">{data.salary.net_take_home_words}</td>
          </tr>
        </tbody>
      </table>

    </div>
                            




                        </div>
                    </div>

                    </div>




				</div>
			</div>









		</>
	);
}

const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(RoleAccessControl);